import { MessageSquare, Star } from 'lucide-react';
import { useTravellerFeedback } from '../../../../context/travellerFeedback/TravellerFeedbackContext';
import { feedbackData } from '../../utils/feedbackHelpers';
import StatCard from './StatCard';

const iconMap = {
  MessageSquare,
  Star
};

const StatsCards = () => {
  const { feedbacks, statistics } = useTravellerFeedback();

  const getStatValue = (cardId) => {
    switch (cardId) {
      case 'total':
        return feedbacks?.length || 0;
      case 'monthAvg':
        return statistics?.current_period?.average_rating
          ? statistics.current_period.average_rating.toFixed(1)
          : '0.0';
      case 'overallAvg':
        return statistics?.all_time?.average_rating
          ? statistics.all_time.average_rating.toFixed(1)
          : '0.0';
      case 'monthlyReviews':
        return statistics?.current_period?.monthly_feedback || 0;
      default:
        return 0;
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
      {feedbackData.statCards.map((card) => (
        <StatCard
          key={card.id}
          label={card.label}
          value={getStatValue(card.id)}
          description={card.description}
          icon={iconMap[card.icon]}
          highlight={card.highlight}
        />
      ))}
    </div>
  );
};

export default StatsCards;
